















































































import { Component, Vue } from 'vue-property-decorator';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BaiduMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BaiduControl from 'vue-baidu-map/components/controls/Control.vue';

@Component({
  components: {
    BaiduMap,
    BaiduMarker,
    BaiduControl
  },
})
export default class production extends Vue {
  map = {
    lat: 113.947534,
    lng: 22.53017,
    width: '520px',
    height: '400px',
    zoom: 19
  };

  timeLineList = [
    {title:'2020',content:'紫金斩获“中国数据中心运维10强”、“中国智能运维服务100强”两项大奖；紫金畅修赢得中国IT服务“创新实践”奖'},
    {title:'2019',content:'中信银行总行营业部授予北京紫金“IT卓越合作伙伴”称号；荣获“2019年中国软件行业最具影响力企业”'},
    {title:'2018',content:'助力河北农信第二代核心业务系统顺利上线；中国建设银行上海市分行的“无人银行”4月9日正式亮相上海九江路，这是中国银行业首家“无人银行”，也是紫金技术助力银行网点智慧化转型的重要成果'},
    {title:'2017',content:'紫金ATMC应用自动测试软件上线'},
    {title:'2016',content:'根据各厂商产品特性，结合存储、网络、安全等厂商的管理组件，运用合适的私有云技术，定制化构造最适合客户环境和需求的私有云架构解决方案'},
    {title:'2015',content:'通过ISO/IEC 27001:2013信息安全管理体系认证和CMMI5级认证\n'},
    {title:'2014',content:'获得了ITSS信息技术服务运行维护标准符合性证书，研发的“一种日志采集方法及系统“、“一种基于XFS命令的调用身份认证方法及系统”、“一种基于ATM设备的U盘授权方法及系统”等三个软件产品获得了国家发明专利'},
    {title:'2013',content:'跻身2013年中国软件百强企业；再度荣获国家规划布局内重点软件企业”'},
    {title:'2012',content:'获得中国光大银行2012年度优秀IT供应商'},
    {title:'2011',content:'为加强对一线维护的技术支持力度，帮助一线维护工程师顺利完成现场的维护工作，紫金技术于成立了硬件技术支持中心；“一种ATM测试方法及装置”获得国家发明专利'},
    {title:'2010',content:'通过ISO20000服务体系认证；荣获2010年国家规划布局内重点软件企业'},
    {title:'2009',content:'深圳公司、北京公司、上海公司先后通过了国家高新技术企业评定，成为我国的第一批国家级高新技术企业；荣获“2009年中国软件服务业企业信用评价”AAA级信用企业；荣获“2009年深圳市百强软件企业”称号'},
    {title:'2008',content:'被评为深圳市第一批自主创新“软件与信息服务行业”龙头企业。 北京奥运会期间，作为多家银行的自助设备主要维护商之一，我司积极开展了一系列金融服务工作，成立奥运维护专项小组，充分发挥服务网络优势，调配备机、备件，在确保全国供给充足的情况下集中力量支持六个奥运城市尤其是北京的奥运维护工作'},
    {title:'2007',content:'南京紫津融畅成立，注册资本1800万元；中国电脑商500强调查评选活动暨“第五届中国电脑商年会”中被评为“分销商150强第43名”'},
    {title:'2006',content:'加入CEN/XFS国际标准化委员会，成为该组织核心成员中的第一家中国公司；荣获深圳市2006年度科技创新奖之“引进消化吸收再创新类创新奖”'},
    {title:'2005',content:'成为CISCO金牌认证合作伙伴；卓越服务 时刻守护——紫金800服务热线开通\n'},
    {title:'2004',content:'紫金成为工行2004年度全行网络及网络安全设备项目供应商，网络项目是紫金和工行长期稳固的重要合作领域之一'},
    {title:'2003',content:'被认定为"深圳市重点软件企业"'},
    {title:'2002',content:'通过ISO9000质量体系认证；“国家软件百强企业”；具有信息系统集成及服务一级资质；"国家规划布局内重点软件企业"'},
    {title:'2001',content:'成为CISCO银牌认证合作伙伴；ISO9001质量体系开始正式启动，在试运行的过程中逐步完善各类质量管理文件，质量管理体系更加完善，不断提高产品质量和管理水平'},
    {title:'2000',content:'成为 CISCO 希望之星；拥有专业的自营团队2500多人 在全国建立了三百多个服务站点，包含了四个直辖市、省会城市以及绝大多数的发达城市'},
    {title:'1999',content:'成为 CISCO 合作之星'},
    {title:'1998',content:'紫金三机双工HA容错系统；紫金ES9000大机延伸对公柜员终端系统；紫金银证互联系统开发及售后服务'},
    {title:'1997',content:'紫金ES9000大机延伸储蓄柜员终端系统\n' +
        '工商银行省级综合网络处理系统\n' +
        '紫金电话银行查询系统的开发及售后服务'},
    {title:'1996',content:'金融POS系统的开发及维护'},
    {title:'1995',content:'紫金IBM4700储蓄仿真业务及对公仿真业务处理系统的售后服务\n' +
        '喜玛拉雅系列容错机银行综合业务处理系统售后服务'},
    {title:'1994',content:'在国内率先成功引进多处理器计算机技术(SMP)\n' +
        '基于COROLLARY小型机的合作银行网络业务处理系统的售后维护'},
    {title:'1993',content:'基于开放式UNIX环境下CLIENT－SERVER结构的金融柜面业务处理系统'},
    {title:'1992',content:'成立 注册资本1.1亿元'},
  ];

  handler ({BMap, map}: any) {
    console.log(BMap, map)
    // this.map.width = document.getElementById('map-container')!.clientWidth - 330+'px';
    // this.map.height = document.body.clientHeight - 160+'px';
    this.map.width = 520 + 'px';
    this.map.height = 400 + 'px';

    this.$nextTick(()=>{
      this.map.lng = 113.947534;
      this.map.lat = 22.53017;
      this.map.zoom = 19;
    })
  }

  created(){

  }
}
